import { atomWithRefresh } from 'infrastructure/state/atomWithRefresh'
import { doAdminQueries } from 'infrastructure/api'
import type { PartnerType } from 'infrastructure/api'
import { useAtomWithErrorNotification } from 'shared/ui/GlobalDialog'

async function fetchPartners() {
  const result = await doAdminQueries<PartnerType[]>([
    {
      resourceData: { key: 'allPartners', fields: ['id', 'name'] },
      params: {},
    },
  ])
  const error = result?.errors?.map(({ message }) => message).join('\n')
  return {
    result: error ? [] : (result.data?.['allPartners'] ?? []),
    errors: result.errors,
    error,
  }
}

export const allPartnersAtom = atomWithRefresh(() => {
  return fetchPartners()
})

/**
 * Hook to retrieve all partners with error handling.
 * @returns Partner list for attribution options, or null while loading
 */
export function useAllPartners() {
  return useAtomWithErrorNotification(
    { errorTitle: 'Error Retrieving Partners' },
    allPartnersAtom,
  )
}

/**
 * Hook to retrieve all partner names.
 * @returns Partner name list for attribution options, or null while loading
 */
export function useAllPartnerNames() {
  const partners = useAllPartners()
  return partners?.map(({ name }) => name)
}
